export { default } from './SentimentGauge';
